import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { EmployeeManagementPageComponent } from './employee-management-page.component';
import { AddEditEmployeeModule } from './add-edit-employee/add-edit-employee.module';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.employeeManagement',
    url: '/employeeManagement',
    component: EmployeeManagementPageComponent,
    data: {
      requireLogin: true
    },
    params: {
      employeeId: null,
      employeeName: null
    }
  }
];

@NgModule({
  declarations: [EmployeeManagementPageComponent],
  imports: [
    CommonModule,
    AddEditEmployeeModule,
    UIRouterModule.forChild({ states })
  ],
  exports: [EmployeeManagementPageComponent],
  entryComponents: [EmployeeManagementPageComponent]
})
export class EmployeeManagementPageModule { }
